import { IconProp } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Box, createStyles, makeStyles, Theme } from '@material-ui/core';
import clsx from 'clsx';
import React, { FunctionComponent, MouseEvent as ReactMouseEvent } from 'react';
import PulseLoader from 'react-spinners/PulseLoader';

export interface Props {
    isDisabled?: boolean;
    isLoading?: boolean;
    isDetail?: boolean;
    icon: IconProp;
    onClick: (event: ReactMouseEvent) => void;
    text: string;
    color?: string;
    id?: string;
}

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        item: {
            'width': '100%',
            'color': '#222',
            'fontSize': 14,
            'fontWeight': 500,
            'lineHeight': 1.95,
            'cursor': 'pointer',
            'margin': '2px 0px',
            'padding': '0px 20px',
            'display': 'inline-block',
            'whiteSpace': 'nowrap',
            'textAlign': 'left',

            '& svg': {
                marginRight: 6,
                verticalAlign: 'middle'
            },

            '&:hover': {
                backgroundColor: '#FAFAFA'
            }
        },
        disabled: {
            'width': '100%',
            'color': '#D3D3D3',
            'fontSize': 14,
            'fontWeight': 500,
            'lineHeight': 1.95,
            'cursor': 'not-allowed',
            'margin': '2px 0px',
            'padding': '0px 20px',
            'display': 'inline-block',

            '& svg': {
                marginRight: 6,
                verticalAlign: 'middle'
            }
        },
        icon: {
            width: '15px',
            [theme.breakpoints.down('lg')]: {
                marginRight: '7px'
            },
            [theme.breakpoints.up('xl')]: {
                marginRight: '10px'
            }
        },
        detail: {
            color: '#EF4F57'
        },
        loading: {
            cursor: 'default'
        },
        loadingSpinner: {
            display: 'inline-flex',
            marginLeft: 8,
            verticalAlign: 'middle'
        }
    })
);

export const ToolbarItem: FunctionComponent<Props> = props => {
    const classes = useStyles();

    const clickHandler = (event: ReactMouseEvent) => {
        if (props.isDisabled || props.isLoading) {
            event.stopPropagation();
            return;
        }

        props.onClick(event);
    };

    return (
        <Box
            onClick={clickHandler}
            id={props.id && props.id.concat('toolbar_item')}
            className={clsx(classes.item, {
                [classes.detail]: props.isDetail,
                [classes.disabled]: props.isDisabled && !props.isLoading,
                [classes.loading]: props.isLoading
            })}
            style={{
                color: props.color
            }}
        >
            <FontAwesomeIcon
                icon={props.icon}
                className={clsx(classes.icon, {
                    [classes.detail]: props.isDetail
                })}
            />

            {props.text}
            {props.isLoading && (
                <span className={classes.loadingSpinner}>
                    <PulseLoader
                        color="#222222"
                        loading
                        size={5}
                    />
                </span>
            )}
        </Box>
    );
};

export default ToolbarItem;
